import { useParams } from 'react-router-dom';

import { FeatureFlag } from 'src/shared/constants';
import { isServer } from 'src/shared/helpers/environment';
import { useTreatment } from 'src/shared/hooks';

export const useProSplit = () => {
  const { orgId } = useParams<{ orgId: string }>();

  const proLandingPageSplitTreatment = useTreatment(
    FeatureFlag.Web.PRO_LANDING_PAGE,
    {
      orgId,
    },
  );

  const isLoading =
    isServer() || typeof proLandingPageSplitTreatment === 'undefined';

  const isProLandingPageSplitOn = proLandingPageSplitTreatment === 'on';

  return { isLoading, isProLandingPageSplitOn };
};
